import baseService from "./base.service";

export type ApiKeyIssuePayload = {
  name?: string | null;
  expiresInDays?: number | null;
  neverExpires?: boolean | null;
  rotateKeyId?: string | null;
};

export const getApiKeys = async () => {
  return baseService
    .get("/api-keys")
    .then((response) => response)
    .catch((error) => {
      console.log("api error:", error);
    });
};

// Swagger: POST /api/api-keys/rotate (baseURL already includes /api)
export const issueApiKey = async (payload: ApiKeyIssuePayload) => {
  return baseService
    .post("/api-keys/rotate", payload)
    .then((response) => response)
    .catch((error) => {
      console.log("api error:", error);
    });
};

export const revokeApiKey = async (id: string) => {
  return baseService
    .delete(`/api-keys/${id}`)
    .then((response) => response)
    .catch((error) => {
      console.log("api error:", error);
    });
};
